
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/family-travel-blog",
      function () {
        return require("private-next-pages/family-travel-blog.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/family-travel-blog"])
      });
    }
  